import { WellCorrelationWidgetWrapper } from '../../well-correlation-widget/WellCorrelationWidget';
import type { WellCorrelationWidgetEntity } from '../../well-correlation-widget/WellCorrelationWidget.entity';

import type { TWidgetRendererOptions } from './WidgetRendererService';

export function renderWellCorrelationWidget(widget: WellCorrelationWidgetEntity, options: TWidgetRendererOptions) {
  return () => <WellCorrelationWidgetWrapper entity={widget} options={options} />;
}
